module.exports = "https://cdn.dashboard.gifty.nl/5596/images/fingerprint-bg.svg?f368a7115c7e3ff8f115643f19856037";